import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const GetCuratorNicknameChangeCountResponseDataSchema = z
  .object({
    currentCount: z.number(),
    maxCount: z.number(),
    remainingCount: z.number(),
  })
  .describe('GetCuratorNicknameChangeCountResponseDataSchema');

const GetCuratorNicknameChangeCountResponseSchema = createApiResponseSchema(
  GetCuratorNicknameChangeCountResponseDataSchema,
);

type GetCuratorNicknameChangeCountResponse = z.infer<
  typeof GetCuratorNicknameChangeCountResponseSchema
>;

export const getCuratorNicknameChangeCount = withApiErrorCapture(
  lazyPipe(
    async () =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetCuratorNicknameChangeCountResponse>(
          profileApiPath.getCuratorNicknameChangeCount,
        ),
      ),
    validateApiResponse(GetCuratorNicknameChangeCountResponseSchema),
  ),
);
